<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BnRmdD/tc-custom/9780802191335.jpg?1701061291506" alt="This image is the cover for the book Secessia"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Secessia
      </h1>
      <p class="bookDescription body article font2">
        <b>The acclaimed author of <i>The Blood of Heaven</i> shares “a vivid portrait of 1862 New Orleans” as Union soldiers take over in this panoramic Civil War novel (Ron Charles, <i>Washington Post</i>).</b><br/><br/>The largest city in the ill-starred confederacy has fallen under the soon-to-be-infamous General Benjamin “the Beast” Butler. And when twelve-year-old Joseph Woolsack disappears from his home, he draws his mother, Elise—a mixed-race woman passing for white—into a dark new world.<br/><br/>Joseph grapples with his father’s legacy of violence and his own growing sentiment for Cuban exile Marina Fandal, the only survivor of a shipwreck that claimed the lives of her parents. Meanwhile, Elise struggles to keep hold of her sanity, her son and her own precarious station. But she soon encounters a troubling figure from her past, a man who is deeply mired in the intrigue surrounding the city’s occupation.<br/><br/>Alternating between the perspectives of five characters, <i>Secessia</i> weaves a tapestry of ravenous greed and malformed love, of slavery and desperation, set within the baroque melting-pot that is New Orleans. A Gothic <i>tableaux vivant</i> of epic scope and intimate horror, <i>Secessia</i> is the netherworld reflection of the conflict between north and south.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kent Wascom
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?adc02cec